__turbopack_context__.v({
  "mobileTabSelect": "topCompaniesCommon-module-scss-module__4O3hUG__mobileTabSelect",
});
